<template>
  <v-card>
    <v-container>
      <v-layout wrap>
        <v-flex
          xs12
          sm6
        >
          <v-text-field
            v-model="$currentOrganization.name"
            :label="$t('name')"
          />
        </v-flex>

        <v-flex
          xs12
          sm6
        >
          <v-select
            v-model="$currentOrganization.settings.defaultCurrency"
            :items="allCurrencies"
            label="Default Currency"
          />
        </v-flex>
      </v-layout>
    </v-container>

    <v-card-actions>
      <v-btn
        v-t="'cancel'"
        text
        :disabled="$currentOrganization.loading || $currentOrganization.saving"
        @click="cancel()"
      />

      <v-spacer />

      <v-btn
        color="success"
        :disabled="$currentOrganization.loading || $currentOrganization.saving"
        :loading="$currentOrganization.saving"
        @click="save()"
      >
        {{ $currentOrganization.isNew() ? $t('create') : $t('save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import allCurrencies from '@/config/currencies'

export default {
  name: 'OrganizationSettings',
  data () {
    return {
      allCurrencies: Object.keys(allCurrencies),
      defaultCurrency: null
    }
  },
  mounted () {
    this.cancel()
  },
  methods: {
    save () {
      // Creator of the org is the owner
      if (this.$currentOrganization.isNew()) {
        this.$currentOrganization.users.push(this.$currentUser.id)
      }

      this.$currentOrganization.save()
      // TODO: if new org created, set as current one
    },
    cancel () {
      this.$currentOrganization.reset()
    }
  }
}
</script>

<style>

</style>
